import { Reveal } from "../motion";
import { useLang } from "../../lib/i18n";

export const Pricing = ({ services }) => {
  const { t, tf } = useLang();
  const groups = services.reduce((acc, s) => {
    (acc[s.category] = acc[s.category] || []).push(s);
    return acc;
  }, {});

  return (
    <section id="tarifs" className="py-28 lg:py-36 bg-white" data-testid="pricing-section">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-[12px] tracking-[0.28em] uppercase text-taupe-dark mb-4">{t("pricing.kicker")}</p>
          <h2 className="font-display tracking-tight text-4xl sm:text-5xl lg:text-6xl text-espresso leading-tight">
            {t("pricing.titleA")} <span className="italic text-taupe">{t("pricing.titleB")}</span>
          </h2>
          <p className="mt-4 text-sm text-espresso/60 font-light">{t("pricing.note")}</p>
        </Reveal>
        <div className="mt-16 space-y-14">
          {Object.entries(groups).map(([category, items], gi) => (
            <Reveal key={category} delay={0.05 * gi}>
              <div data-testid={`pricing-group-${gi}`}>
                <h3 className="text-[13px] tracking-[0.22em] uppercase text-taupe-dark border-b border-taupe/30 pb-4">
                  {tf(`cat.${category}`, category)}
                </h3>
                <ul>
                  {items.map((s) => (
                    <li
                      key={s.id}
                      data-testid={`pricing-item-${s.id}`}
                      className="group flex items-baseline justify-between gap-6 py-5 border-b border-taupe/15 hover:bg-cream/60 transition-colors duration-300 px-2 -mx-2 rounded"
                    >
                      <div>
                        <p className="font-display text-xl lg:text-2xl text-espresso">{tf(`svcName.${s.name}`, s.name)}</p>
                        {s.description && (
                          <p className="text-sm text-espresso/55 font-light mt-1 max-w-lg">{tf(`svcDesc.${s.name}`, s.description)}</p>
                        )}
                      </div>
                      <div className="flex items-baseline gap-6 shrink-0">
                        <span className="hidden sm:block text-xs tracking-[0.14em] uppercase text-espresso/45">
                          {s.duration} {t("pricing.min")}
                        </span>
                        <span className="font-display text-xl lg:text-2xl text-taupe-dark">{s.price_label}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
